import * as angular from 'angular';
import {
    downgradeComponent,
    downgradeInjectable
} from '@angular/upgrade/static';
import { CollapsePanelComponent } from 'angular/custom/components/collapse-panel.component';
import { ToggleComponent } from 'angular/custom/components/toggle.component';
import { Growl } from 'angular/custom/services/growl.service';
import { MultiYearCapacityComponent } from 'angular/auctions/multi-year/multi-year-capacity.component';
import { StorageAdvancedSettingsComponent } from 'angular/storage/storage-advanced-settings.component';
import { LngAdvancedSettingsComponent } from 'angular/lng/lng-advanced-settings.component';
import { TogglePanelComponent } from 'angular/custom/components/toggle-panel.component';
import { MultiYearCapacityDetailsComponent } from 'angular/auctions/multi-year/multi-year-capacity-details.component';
import { LoadingComponent } from 'angular/custom/components/loading.component';
import { TimerComponent } from 'angular/custom/components/timer.component';
import { StorageAdminPrismaCreditLimitCheckComponent } from 'angular/storage/storage-admin-prisma-credit-limit-check.component';
import { LngAdminPrismaCreditLimitCheckComponent } from 'angular/lng/lng-admin-prisma-credit-limit-check.component';
import { TsoSubscriptionsComponent } from 'angular/operator-settings/tso-subscriptions.component';

[
    {
        pkpStorageAdvancedSettings: downgradeComponent({
            component: StorageAdvancedSettingsComponent
        })
    },
    {
        pkpStorageAdminPrismaCreditLimitCheck: downgradeComponent({
            component: StorageAdminPrismaCreditLimitCheckComponent
        })
    },
    {
        pkpLngAdvancedSettings: downgradeComponent({
            component: LngAdvancedSettingsComponent
        })
    },
    {
        pkpLngAdminPrismaCreditLimitCheck: downgradeComponent({
            component: LngAdminPrismaCreditLimitCheckComponent
        })
    },
    {
        pkpCollapsePanel: downgradeComponent({
            component: CollapsePanelComponent
        })
    },
    { pkpTogglePanel: downgradeComponent({ component: TogglePanelComponent }) },
    { pkpToggle: downgradeComponent({ component: ToggleComponent }) }
].forEach((component) => angular.module('app').directive(component));

angular
    .module('app')
    .directive(
        'pkpMultiYearCapacity',
        downgradeComponent({
            component: MultiYearCapacityComponent
        }) as angular.IDirectiveFactory
    )
    .directive(
        'pkpMultiYearCapacityDetails',
        downgradeComponent({
            component: MultiYearCapacityDetailsComponent
        }) as angular.IDirectiveFactory
    )
    .directive(
        'loading',
        downgradeComponent({
            component: LoadingComponent
        }) as angular.IDirectiveFactory
    )
    .directive(
        'timer',
        downgradeComponent({
            component: TimerComponent
        }) as angular.IDirectiveFactory
    )
    .directive(
        'pkpTsoSubscriptions',
        downgradeComponent({
            component: TsoSubscriptionsComponent
        }) as angular.IDirectiveFactory
    );

angular.module('app').factory('growl', downgradeInjectable(Growl));
